import type { TaskType } from '@econtractor/types';
import { isOverdueTask } from '../KanbanCard';

/** Прострочені зверху; серед них — найдавніше прострочені першими */
export const sortBoardTasks = (list: TaskType[]): TaskType[] =>
    [...list].sort((a, b) => {
        const aOverdue = isOverdueTask(a);
        const bOverdue = isOverdueTask(b);
        if (aOverdue !== bOverdue) return aOverdue ? -1 : 1;
        if (aOverdue && bOverdue) {
            return Number(a.dateEnd || 0) - Number(b.dateEnd || 0);
        }
        return 0;
    });

export const findTaskColumnStatus = (
    columns: Array<{ status: number; tasks: TaskType[] }>,
    taskId: number,
): number | null => {
    for (const col of columns) {
        if (col.tasks.some((task) => task.ID === taskId)) return col.status;
    }
    return null;
};
